import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import PDPProtectionPlanSelector from 'components/consumer/PDP/PDPProtectionPlanSelector';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useIsBrowser from 'hooks/useIsBrowser';
import PDPMobileGalleryRevamp from '../PDPMobileGalleryRevamp';
import PDPKeySellingPoints from '../PDPKeySellingPoints';
import PDPNameSection from '../PDPNameSection';
import PDPShopTabsBar from '../PDPShopTabsBar';
import PDPAvailableInSizes from '../PDPAvailableInSizes';
import PDPOnDisplayInShowroom from '../PDPOnDisplayInShowroom';
import PDPAddToBagSection from '../PDPAddToBagSection';
import PDPUpSellProduct from '../PDPUpSellProduct';
import PDPCustomerPhotos from '../PDPCustomerPhotos';
import PDPBreadCrumbs from '../PDPBreadCrumbs';
import PDPAlertBar from '../PDPAlertBar';
import PDPAlertsSection from '../PDPAlertsSection';
import PDPDiscontinuedMessage from '../PDPDiscontinuedMessage';
import PDPChooseYourOptions from '../PDPChooseYourOptions';
import PDPGalleryLabels from '../PDPGalleryLabels';
import PDPDecideLaterButton from '../PDPDecideLaterButton';
import PDPInfoAccordion from '../PDPInfoAccordion';
import PDPSectionDivider from '../PDPSectionDivider';
import PDPCuralateGallery from '../PDPFooter/PDPCuralateGallery';
import { PDPRecentlyViewed } from '../PDPFooter';
const PDPCollectionSlider = loadable(() => import('../PDPCollectionSlider'));

/**
 * Mobile layout for the CON-8777 test variant: PDPMobile's components in the
 * new order. BYO and edit-order stay on PDPMobile. The variant is designed on
 * top of the redesigned gallery, so it renders that directly rather than
 * branching on the gallery flag.
 */
const PDPMobileRevamp = t0 => {
  const $ = _c(60);
  const {
    discontinuedCategoryMsg: t1,
    isOutOfStock: t2,
    showDiscontinuedNotification: t3,
    showOutOfStockNotification: t4,
    slug,
    productHeroImage: t5,
    productCylindoHeroImage: t6
  } = t0;
  const discontinuedCategoryMsg = t1 === undefined ? null : t1;
  const isOutOfStock = t2 === undefined ? false : t2;
  const showDiscontinuedNotification = t3 === undefined ? false : t3;
  let t7;
  if ($[0] !== t4) {
    t7 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const showOutOfStockNotification = t7;
  const productHeroImage = t5 === undefined ? null : t5;
  const productCylindoHeroImage = t6 === undefined ? null : t6;
  const isBrowser = useIsBrowser();
  const [displayPressComp, setDisplayPressComp] = useState(false);
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mb-4"><PDPBreadCrumbs /></div>;
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  let t9;
  if ($[3] !== productCylindoHeroImage || $[4] !== productHeroImage || $[5] !== slug) {
    t9 = <div><PDPMobileGalleryRevamp slug={slug} productHeroImage={productHeroImage} productCylindoHeroImage={productCylindoHeroImage} hideProductLabel={true} /></div>;
    $[3] = productCylindoHeroImage;
    $[4] = productHeroImage;
    $[5] = slug;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  let t11;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FixedWidthContainer><PDPGalleryLabels /></FixedWidthContainer>;
    t11 = <PDPNameSection disableStickyPriceRow={true} hideProductLabel={true} hideRatings={true} />;
    $[7] = t10;
    $[8] = t11;
  } else {
    t10 = $[7];
    t11 = $[8];
  }
  let t12;
  if ($[9] !== isBrowser) {
    t12 = isBrowser ? <PDPAvailableInSizes /> : <div className="PDP__PDPAvailableInSizes-filler" />;
    $[9] = isBrowser;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  let t14;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <PDPOnDisplayInShowroom />;
    t14 = <hr className="border-0 border-t border-gray-light7 my-6" />;
    $[11] = t13;
    $[12] = t14;
  } else {
    t13 = $[11];
    t14 = $[12];
  }
  let t15;
  if ($[13] !== t12) {
    t15 = <FixedWidthContainer>{t12}{t13}{t14}</FixedWidthContainer>;
    $[13] = t12;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  if ($[15] !== discontinuedCategoryMsg || $[16] !== showDiscontinuedNotification) {
    t16 = showDiscontinuedNotification ? <PDPAlertBar type="error"><PDPDiscontinuedMessage discontinuedCategoryMsg={discontinuedCategoryMsg} /></PDPAlertBar> : <div className="PDPMobile__PDPAlertBar-filler" />;
    $[15] = discontinuedCategoryMsg;
    $[16] = showDiscontinuedNotification;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== isOutOfStock || $[19] !== showDiscontinuedNotification) {
    t17 = !isOutOfStock && !showDiscontinuedNotification ? <div className="PDPMobile__PDPChooseYourOptions-wrapper"><PDPShopTabsBar hideDecideLaterTab={true} isLayoutRevamp={true} /><PDPDecideLaterButton /><PDPChooseYourOptions isLayoutRevamp={true} /></div> : <div className="PDPMobile__PDPChooseYourOptions-wrapper-filler" />;
    $[18] = isOutOfStock;
    $[19] = showDiscontinuedNotification;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== isOutOfStock || $[22] !== showDiscontinuedNotification || $[23] !== showOutOfStockNotification) {
    t18 = isOutOfStock && !showDiscontinuedNotification ? <PDPAlertsSection showOutOfStockNotification={showOutOfStockNotification} /> : <div className="PDPMobile__PDPAlertSection-filler" />;
    $[21] = isOutOfStock;
    $[22] = showDiscontinuedNotification;
    $[23] = showOutOfStockNotification;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== showDiscontinuedNotification) {
    t19 = !showDiscontinuedNotification && <hr className="border-0 border-t border-gray-light7 my-6" />;
    $[25] = showDiscontinuedNotification;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== isOutOfStock) {
    t20 = <PDPAddToBagSection isOutOfStock={isOutOfStock} isLayoutRevamp={true} />;
    $[27] = isOutOfStock;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== isOutOfStock || $[30] !== showDiscontinuedNotification) {
    t21 = !isOutOfStock && !showDiscontinuedNotification ? <><PDPUpSellProduct isLayoutRevamp={true} /><PDPProtectionPlanSelector isLayoutRevamp={true} /></> : <div className="PDPMobileRevamp__add-ons-filler" />;
    $[29] = isOutOfStock;
    $[30] = showDiscontinuedNotification;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18 || $[35] !== t19 || $[36] !== t20 || $[37] !== t21) {
    t22 = <div>{t16}{t17}{t18}{t19}{t20}{t21}</div>;
    $[32] = t16;
    $[33] = t17;
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  let t24;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <PDPKeySellingPoints mobileCarousel={true} />;
    t24 = <PDPInfoAccordion />;
    $[39] = t23;
    $[40] = t24;
  } else {
    t23 = $[39];
    t24 = $[40];
  }
  let t25;
  if ($[41] !== t22) {
    t25 = <FixedWidthContainer>{t22}{t23}{t24}</FixedWidthContainer>;
    $[41] = t22;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] !== displayPressComp) {
    t26 = !displayPressComp ? <><PDPSectionDivider className="my-8" /><SuspenseWithLoader><PDPCollectionSlider setDisplayPressComp={setDisplayPressComp} isLayoutRevamp={true} /></SuspenseWithLoader></> : <div className="PDPMobile__PDPPress-filler" />;
    $[43] = displayPressComp;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  let t28;
  let t29;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <PDPSectionDivider className="my-8" />;
    t28 = <PDPCuralateGallery isLayoutRevamp={true} />;
    t29 = <PDPSectionDivider className="my-8" />;
    $[45] = t27;
    $[46] = t28;
    $[47] = t29;
  } else {
    t27 = $[45];
    t28 = $[46];
    t29 = $[47];
  }
  let t30;
  if ($[48] !== slug) {
    t30 = <PDPCustomerPhotos slug={slug} isLayoutRevamp={true} />;
    $[48] = slug;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <PDPSectionDivider className="my-8" />;
    $[50] = t31;
  } else {
    t31 = $[50];
  }
  let t32;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <SuspenseWithLoader><PDPRecentlyViewed isLayoutRevamp={true} /></SuspenseWithLoader>;
    $[51] = t32;
  } else {
    t32 = $[51];
  }
  let t33;
  if ($[52] !== t26 || $[53] !== t30) {
    t33 = <FixedWidthContainer className="max-md:!px-4">{t26}{t27}{t28}{t29}{t30}{t31}{t32}</FixedWidthContainer>;
    $[52] = t26;
    $[53] = t30;
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  let t34;
  if ($[55] !== t15 || $[56] !== t25 || $[57] !== t33 || $[58] !== t9) {
    t34 = <div className="PDPMobileRevamp lg:hidden" data-xc="PDPMobileRevamp">{t8}{t9}{t10}{t11}{t15}{t25}{t33}</div>;
    $[55] = t15;
    $[56] = t25;
    $[57] = t33;
    $[58] = t9;
    $[59] = t34;
  } else {
    t34 = $[59];
  }
  return t34;
};
PDPMobileRevamp.propTypes = {
  discontinuedCategoryMsg: PropTypes.shape({
    category: PropTypes.string,
    link: PropTypes.string
  }),
  isOutOfStock: PropTypes.bool,
  showDiscontinuedNotification: PropTypes.bool,
  showOutOfStockNotification: PropTypes.shape({
    productId: PropTypes.number,
    show: PropTypes.bool
  }),
  slug: PropTypes.string,
  productHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  }),
  productCylindoHeroImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string
  })
};
export default PDPMobileRevamp;